module.exports = window.dataLayer;